import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FacilityService } from '../services/facility.service';
import { FlagObject, HaloTipsOption } from './halo-tips.model';
import { HaloTipsService } from './halo-tips.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Component({
  selector: 'app-halo-tips',
  templateUrl: './halo-tips.component.html',
  styleUrls: ['./halo-tips.component.scss']
})
export class HaloTipsComponent implements OnInit {
  public option: HaloTipsOption | any;
  public total: number = 0;
  public current: number = 0;
  rootScopeData: RootScopeDeclare | any;

  @ViewChild('halotip', { static: false }) _htq: ElementRef;

  constructor(
    public service: HaloTipsService,
    private _facilityService: FacilityService,
    private rootScopeService: RootScopeService) {
    this.service.countSource.subscribe(res => {
      this.total = res;
      this.current = 1;
    });
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.service.firstOptionSource.subscribe(op => {
      this.option = op;
      if(this.option?.pointerPosition == 'bottom'){
        setTimeout(() => {
          if(!this._htq) return;
          const htRect = this._htq.nativeElement.getBoundingClientRect();
          this.option.top = this.option.top ? this.option.top - htRect.height - 20 : htRect.height - 20;
        });        
      } else if(this.option?.position == 'left') {
        setTimeout(() => {
          if(!this._htq) return;
          const htRect = this._htq.nativeElement.getBoundingClientRect();
          this.option.pointLeft = htRect.width - 7;
          this.option.left = this.option.left - htRect.width - 30;
        });  
      }
    });
  }

  top(option: HaloTipsOption) {
    if (!option) return;
  }

  async onDismiss(flag:string, action: string) {
    if (action === 'gotIt' && this.current === this.total) {
      const flagsToUpdate: FlagObject = {};
      flagsToUpdate[flag] = false;
      this._facilityService.updatedFacilityPreferenceForUser(flagsToUpdate);
      if (this.rootScopeData.hasOwnProperty(flag)) {
        this.rootScopeData[flag]= false;
      }
    }

    this.current++;
    this.option = null;
    this.service.onDismissed(action==='gotIt' || action==='skip');
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  updateRootScopeData(): void {
    this.rootScopeService.updateRootScope(this.rootScopeData);
  }
}